import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CATEGORIES } from "../lib/categories";
import EventCard from "../components/EventCard";

const CITIES = ["All cities", "Hyderabad", "Bangalore"];

export default function Events() {
  const [events, setEvents] = useState([]);
  const [cat, setCat] = useState("all");
  const [city, setCity] = useState("All cities");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (cat !== "all") params.category = cat;
    if (city !== "All cities") params.city = city;
    api.get("/events", { params })
      .then((r) => setEvents(r.data))
      .finally(() => setLoading(false));
  }, [cat, city]);

  return (
    <div data-testid="events-page" className="max-w-6xl mx-auto px-6 md:px-10 pt-12 md:pt-20 pb-20">
      <div className="label-eyebrow">Curated weekly · in person</div>
      <h1 className="font-serif text-5xl md:text-6xl mt-4 leading-tight">
        Gatherings.
      </h1>
      <p className="mt-5 max-w-2xl text-lg" style={{ color: "var(--text-muted)" }}>
        Small, in-person things happening across Hyderabad, Bangalore and Pune. Tap <em>RSVP</em> on anything that pulls at you — your name reaches the host directly.
      </p>

      <div className="mt-10 space-y-4">
        <div className="flex flex-wrap gap-2" data-testid="city-filters">
          <span className="label-eyebrow self-center mr-1">City</span>
          {CITIES.map((c) => (
            <button
              key={c}
              data-testid={`city-${c.toLowerCase().replace(/\s/g, '-')}`}
              data-active={city === c}
              onClick={() => setCity(c)}
              className="chip"
            >
              {c}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap gap-2" data-testid="category-filters">
          <span className="label-eyebrow self-center mr-1">Kind</span>
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              data-testid={`filter-${c.id}`}
              data-active={cat === c.id}
              onClick={() => setCat(c.id)}
              className="chip"
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-12">
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1,2,3].map((i) => (
              <div key={i} className="card-warm">
                <div className="aspect-[4/3] animate-pulse" style={{ background: "var(--accent-2)", opacity: 0.4 }} />
                <div className="p-6 space-y-3">
                  <div className="h-4 w-1/3 animate-pulse rounded" style={{ background: "var(--line)" }} />
                  <div className="h-6 w-3/4 animate-pulse rounded" style={{ background: "var(--line)" }} />
                </div>
              </div>
            ))}
          </div>
        ) : events.length === 0 ? (
          <div data-testid="events-empty" className="card-warm p-12 text-center">
            <p className="font-serif text-3xl">Nothing in this corner yet.</p>
            <p className="mt-3" style={{ color: "var(--text-muted)" }}>
              Try a different city or kind — we add things slowly, on purpose.
            </p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {events.map((e, i) => <EventCard key={e.id} event={e} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
